module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n    "), (!_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user-white.png"),
      "width": "18",
      "height": "18"
    },
    slot: "label"
  })]) : _vm._e(), _vm._v(" "), (_vm.userName) ? _c('a', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        _vm.goLogin()
      }
    },
    slot: "right"
  }, [_vm._v("\n      " + _vm._s(_vm.userName) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('cell-box', {
    staticStyle: {
      "margin-top": "46px"
    }
  }, [_c('flexbox', {
    attrs: {
      "orient": "vertical",
      "align": "center"
    }
  }, [_c('flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "artcleTitle"
  }, [_vm._v(_vm._s(_vm.article.title))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "articleTip"
  }, [_vm._v("作者：" + _vm._s(_vm.article.staffName))]), _c('span', {
    staticClass: "articleTip"
  }, [_vm._v("发布时间：" + _vm._s(_vm.article.sendTime))]), _c('span', {
    staticClass: "articleTip"
  }, [_vm._v("查看次数：" + _vm._s(_vm.article.readTimes))])])]), _vm._v(" "), _c('flexbox-item', [(_vm.article.jian != '') ? _c('div', {
    staticClass: "Brief"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("简述：")]), _vm._v(" "), _c('p', {
    staticClass: "context"
  }, [_vm._v(_vm._s(_vm.article.jian))])]) : _vm._e(), _vm._v(" "), (_vm.image != '') ? _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.imageSrc
    }
  })]) : _vm._e()]), _vm._v(" "), _c('flexbox-item', [_c('div', {
    staticClass: "articleContext",
    domProps: {
      "innerHTML": _vm._s(_vm.article.context)
    }
  })]), _vm._v(" "), _c('flexbox-item', [(_vm.article.fileName != '') ? _c('div', [_vm._v("\n                附件："), _c('a', {
    staticStyle: {
      "color": "#0772e0"
    },
    on: {
      "click": function($event) {
        _vm.getFilePath()
      }
    }
  }, [_vm._v(_vm._s(_vm.article.fileName))])]) : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd8f640","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Content.vue
// module id = PNYP
// module chunks = 1